import { useParams } from 'react-router-dom';

import { FeatureResponse } from '../../client';
import {
  useAppNavigate,
  useFeature,
  useRequireFeatureFlagIfProvided,
  useTeam,
  useDocumentTitle,
  useSimulationStatus,
} from '../../hooks';

import { Money } from '../atoms';
import { QueryResult } from '../molecules';
import { Page, TasksList } from '../organisms';

export function FeaturePage() {
  const { featureId } = useParams();
  const navigate = useAppNavigate();
  const team = useTeam();
  const showFeatureEarnings = useRequireFeatureFlagIfProvided('show_feature_earnings');
  const simulationStatus = useSimulationStatus();

  if (featureId === undefined) {
    throw new Error('featureId must be provided');
  }

  const feature = useFeature(featureId);

  useDocumentTitle(`${team.name} / ${featureId}`);

  return (
    <Page title={`Feature #${featureId}`}>
      <QueryResult
        query={feature}
        renderAs={(data) => (
          <>
            {showFeatureEarnings && data.feature.current_earnings != null && <EarnedBox>{data.feature}</EarnedBox>}
            <TasksList
              team={team}
              tasks={data.tasks}
              onTaskClick={(task) => navigate.toTask(task)}
              simulationState={simulationStatus.state}
            />
          </>
        )}
      />
    </Page>
  );
}

interface EarnedBoxProps {
  children: FeatureResponse;
}

function EarnedBox({ children }: EarnedBoxProps) {
  return (
    <div className="p-3 rounded-md bg-bg-muted mb-2">
      <p>
        Earnings rate: <Money colorScheme="light">{children.earnings_rate}</Money>/sec
        <br />
        This feature has earned the company&nbsp;<Money colorScheme="dark">{children.current_earnings}</Money> so far.
      </p>
    </div>
  );
}
